import { useEffect, useState } from 'react';
import useGetHook from '../../customHooks/useGetHook';
import { classNames } from '../../utils/classNames';
import Card from '../Reusable/Card';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
const GridCard = (props: any) => {
  const { item, onClick, props: filterPrams, activeCard, date } = props;
  const {
    data: gridDataInfo,
    isLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      'overview',
      `${item?.slug}-${JSON.stringify(filterPrams)}-${JSON.stringify(
        date
      )}-${JSON.stringify(item?.status)}`,
    ],
    url: `${item?.service_endpoint}`,
    params: {
      slug: item?.slug,
      delivery_status__in: item?.status.map((x) => x.id).join(','),
      created__range: date,
      ...filterPrams,
    },
  });
  const [card, setCard] = useState(null);

  return (
    <>
      <Card
        onClick={() => {
          {
            item?.slug === activeCard
              ? onClick('')
              : onClick(item?.status.map((x) => x.id).join(','), item?.slug);
          }
        }}
      >
        <div
          className={classNames(
            item?.slug === activeCard
              ? tw`bg-primary-active text-primary  py-auto `
              : tw``,
            tw`rounded-md h-full flex flex-col justify-between`
          )}
        >
          <div
            className={tw`uppercase text-primary  font-semibold cursor-pointer mx-2 pt-2`}
          >
            {item?.name}
          </div>
          {isLoading || isRefetching ? (
            <div
              className={tw`flex justify-between mx-3 mt-6 pb-2  animate-pulse`}
            >
              <div className={tw`w-10 bg-gray-300 rounded-lg h-3 `}></div>
              <div className={tw`w-20 bg-gray-300 rounded-lg h-3 `}></div>
            </div>
          ) : (
            <div className={tw`flex flex-wrap justify-between mx-3 mt-4  `}>
              <p className={tw`font-medium text-lg`}>{gridDataInfo?.count}</p>
              <p className={tw`font-medium text-lg`}>
                Rs.{gridDataInfo?.amount}
              </p>
            </div>
          )}
        </div>
      </Card>
    </>
  );
};
export default GridCard;
